// Хук для доступа из любых компонентов
let popupRef = null

export function setPopupRef(ref) {
	popupRef = ref
}

export function openPopup(id, component, props = {}) {
	popupRef?.openPopup(id, component, props)
}

export function closePopup(id) {
	popupRef?.closePopup(id)
}

export function closeAllPopups() {
	popupRef?.closeAllPopups()
}
